import React from "react";
import "./ui.css";
import { Btn, FormInput } from "../../utils/utils";
import EachAgent from "./EachAgent";
import Pagination from "../../utils/pagination";

const AgentBodyComp = ({
  agentData,
  clickNext,
  clickPrev,
  changeInput,
  searchBtn,
  loading,
  rest,
}) => {
  const agentArr = agentData?.data;

  return (
    <div className="agent-body">
      <div className="agent-body_left">
        <h3>Search</h3>
        <div className="agent-body_form">
          <FormInput
            type={"text"}
            label={"Landlord Name"}
            id={"agentName"}
            labelBg={"#FFF8F2"}
            changeInput={changeInput}
            {...rest}
          />
          <FormInput
            type={"text"}
            label={"Landlord ID"}
            id={"agentId"}
            labelBg={"#FFF8F2"}
            changeInput={changeInput}
            {...rest}
          />
          <FormInput
            type={"text"}
            label={"Location"}
            id={"location"}
            labelBg={"#FFF8F2"}
            changeInput={changeInput}
            {...rest}
          />
        </div>
        <div className="agent-body_btn-choice">
          {/* <div className="btn-choice_btn">
            <Btn btnLink={"/agents"} btnText={"Buy"} btnClass={"home-btn_trans"} btnWidth={"100%"} />
            </div>
            <div className="btn-choice_btn">
            <Btn btnLink={"/agents"} btnText={"Rent"} btnClass={"home-btn_trans"} btnWidth={"100%"} />
            </div> */}
        </div>
        <div className="agent-body_btn">
          <Btn
            btnClick={searchBtn}
            btnText={"Search"}
            btnClass={"home-btn"}
            btnWidth={"100%"}
            loading={loading}
          />
        </div>
      </div>
      <div className="agent-body_right">
        <div className="agent-right_cont">
          {agentArr?.map((item, i) => {
            return <EachAgent key={i} agentData={item} />;
          })}
        </div>
        <Pagination
          pagData={agentData?.pagination}
          clickNext={clickNext}
          clickPrev={clickPrev}
        />
      </div>
    </div>
  );
};

export default AgentBodyComp;
